/**
 * Errores del API del mapa. Los servicios devolvían `undefined` en silencio cuando la
 * respuesta no era correcta, así que el mapa se quedaba sin capa y el usuario no veía nada.
 * Ahora lanzan un Error que lleva el estado HTTP para poder dar el aviso adecuado.
 */
export type ErrorDeMapa = Error & { status?: number }

export function errorDeRespuesta(status: number): ErrorDeMapa {
  const error = new Error(`respuesta ${status} del API`) as ErrorDeMapa
  error.status = status
  return error
}

/** Estado HTTP de un error de estos, si lo trae. */
export function estadoDeError(error: unknown): number | undefined {
  const status = (error as ErrorDeMapa | undefined)?.status
  return typeof status === 'number' ? status : undefined
}

/**
 * El API responde 413 (o 422) cuando la selección es demasiado extensa para servir el
 * detalle por secciones (todas las secciones de varias comunidades no caben en memoria).
 * No es un fallo: el mapa debe bajar a la vista provincial, no dar error.
 */
export function esZonaDemasiadoExtensa(status?: number): boolean {
  return status === 413 || status === 422
}

export type AvisoZona = { title: string; message: string }

const AVISO_GENERICO: AvisoZona = {
  title: 'No hemos podido cargar el mapa',
  message: 'Ha fallado la carga de esta zona. Vuelve a intentarlo en unos segundos.',
}

/** Mensaje que ve el usuario cuando la zona seleccionada no se puede cargar. */
export function avisoDeZona(status?: number): AvisoZona {
  if (status === 404) {
    return {
      title: 'Sin datos para esta zona',
      message: 'No hemos encontrado datos para la selección que has hecho. Prueba con otra zona.',
    }
  }
  return AVISO_GENERICO
}

/**
 * Aviso que se muestra encima del mapa cuando la selección no admite el detalle por
 * secciones: en lugar de dejar la zona vacía, se pinta el mapa por provincias.
 */
export const AVISO_VISTA_PROVINCIAL =
  'La zona seleccionada es demasiado grande para el detalle por secciones: ' +
  'te mostramos el mapa por provincias. Elige una provincia o un municipio para bajar al detalle.'
